import { Box, Paper, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Table, IconButton, Button, Dialog, DialogContent, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import edit from '../../../assets/images/editIcon.png'
import { CancelOutlined, DeleteOutline } from '@mui/icons-material'
import { useParams } from 'react-router-dom'
import { ApiCreateBusinessHoliday, ApiDeleteBusinessHolidays, ApiDeleteHoliday, ApiGetBusinessHolidays, ApiUpdateBusinessHoliday, } from '../../../apiService/Core/Apicall.tsx'
import { toast } from 'react-toastify'


function AddorUpdateHolidays() {
    const [holidaylist, setHolidayList] = useState<any[]>([])
    const [openDialog, setOpenDilaog] = useState<boolean>(false)
    const [selectedHoliday, setSelectedHoliday] = useState<number | string | null>(null)
    const [holidayName, setHolidayName] = useState("");
    const [holidayDate, setHolidayDate] = useState("");


    const { id } = useParams()


    const handleCreate = async () => {
        if(!holidayDate) { window.alert("Please select a date to create holiday"); return}
        try {
            const data = {
                "clientEntityId": id,
                "date": holidayDate,
                "holidayName": holidayName?.trim(),
                "createdBy": Number(localStorage.getItem('createdBy'))
            }
            const data2 = {
                "businessHolidayId": selectedHoliday,
                "date": holidayDate,
                "holidayName": holidayName?.trim(),
                "modifiedBy": Number(localStorage.getItem('createdBy'))
            }
            const res = selectedHoliday ? await ApiUpdateBusinessHoliday(data2) : await ApiCreateBusinessHoliday(data)
            if (res?.status || res?.success) {
                getHolidays()
                handleCloseDialog();
            }
        } catch (error: any) {
            toast.error(error)
        }
    };

    const EditHoliday = (item: any) => {
        setHolidayDate(item?.date)
        setHolidayName(item?.holidayName)
        setSelectedHoliday(item?.businessHolidayId)
        setOpenDilaog(true)
    }
    const DeleteHoliday = async (item: any) => {
        const isConfirm = window.confirm('Are you sure you want to delete this holiday ?')
        if (isConfirm) {
            try {
                const data = `?businessHolidayId=${item?.businessHolidayId}`
                const res = await ApiDeleteBusinessHolidays(data)
                if (res?.status || res?.success) {
                    getHolidays()
                }
            } catch (error: any) {
                toast.error(error)
            }
        }
        else {
            return
        }
    }
    const getHolidays = async () => {
        try {
            const data = `?clientEntityId=${id}`

            const response = await ApiGetBusinessHolidays(data)
            if (response?.status || response?.success) {
                setHolidayList(response.data)
            }

        } catch (error: any) {
            toast.error(error)
        }
    }

    useEffect(() => {
        getHolidays()
    }, [])


    const handleCloseDialog = () => {
        setOpenDilaog(false)
        setHolidayName("")
        setHolidayDate("")
        setSelectedHoliday(null)
    }

    return (
        <Box className='p-3 h-100 w-100'>
            <Typography variant='h4' className='text-center mb-4' fontWeight={'bolder'}>Manage Holidays</Typography>
            <Box className='d-flex justify-content-end mb-3'>
                <Button className="table-row-background text-white fs-14" onClick={() => {
                    setHolidayName("");
                    setHolidayDate("");
                    setSelectedHoliday(null); setOpenDilaog(true)
                }} sx={{ textTransform: 'none' }}>
                    Add Holiday
                </Button>
            </Box>
            <TableContainer
                component={Paper}
                sx={{ border: "1px solid #ccc" }}
            >
                <Table>
                    <TableHead sx={{ bgcolor: "#75724C" }}>
                        <TableRow>
                            <TableCell>
                                <Typography className='text-white' variant='subtitle2'>Holiday Title</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography className='text-white text-center' variant='subtitle2'>Date</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography className='text-center text-white' variant='subtitle2'>Day</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography className='text-center text-white' variant='subtitle2'>Actions</Typography>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {holidaylist?.length > 0 ? (
                            holidaylist?.map((item: any, index: number) => (
                                <TableRow>
                                    <TableCell>
                                        <Typography className='' variant='subtitle2'>{item?.holidayName}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography className='text-center' variant='subtitle2'>
                                            {new Date(item?.date).toLocaleDateString('en-GB')}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography className='text-center' variant="subtitle2">
                                            {new Date(item?.date).toLocaleDateString('en-GB', { weekday: 'long' })}
                                        </Typography>
                                    </TableCell>
                                    <TableCell className='text-center d-flex align-items-center justify-content-center' sx={{ gap: '10px' }} >
                                        <Box component={'img'} sx={{ cursor: "pointer" }} src={edit} height={'24px'} width={'24px'} onClick={() => { EditHoliday(item) }} ></Box>
                                        <IconButton onClick={() => { DeleteHoliday(item) }} className='m-0 p-0'><DeleteOutline sx={{ color: 'red' }} /></IconButton>
                                    </TableCell>
                                </TableRow>
                            ))

                        ) : (<TableRow><TableCell colSpan={12}><Typography className='text-center'>No Holidays Found</Typography></TableCell></TableRow>)
                        }
                    </TableBody>

                </Table>

            </TableContainer>


            <Dialog open={openDialog} maxWidth="sm" fullWidth>
                <DialogContent>
                    <Box display="flex" alignItems={'center'} justifyContent="space-between">
                        <Typography variant='h5'>{selectedHoliday ? "Update":"Create"} Holiday</Typography>
                        <IconButton onClick={() => handleCloseDialog()}>
                            <CancelOutlined />
                        </IconButton>
                    </Box>

                    <Box display="flex" className='my-3' flexDirection="column" gap={2}>
                        <TextField
                            label="Holiday Name"
                            fullWidth
                            size="small"
                            value={holidayName}
                            onChange={(e) => setHolidayName(e.target.value)}
                        />

                        <TextField
                            label="Holiday Date"
                            type="date"
                            fullWidth
                            size="small"
                            value={holidayDate}
                            onChange={(e) => setHolidayDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Box>
                    <Box className='d-flex justify-content-end'>
                        <Button className="table-row-background text-white fs-14" sx={{ textTransform: 'none' }} onClick={() => { handleCreate() }}> {selectedHoliday ? "Update":"Create"}</Button>

                    </Box>

                </DialogContent>
            </Dialog>
        </Box>
    )
}

export default AddorUpdateHolidays
